import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import type { EslConfigRequest } from '@/api/endpoints/esl'
import { eslApi } from '@/api/endpoints/esl'

export function useRestaurantEslConfig(restaurantId: number) {
  return useQuery({
    queryKey: ['restaurantEslConfig', restaurantId],
    queryFn: () => eslApi.getConfig(restaurantId),
    staleTime: 0,
  })
}

export function useSaveRestaurantEslConfig(restaurantId: number) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (body: EslConfigRequest) =>
      eslApi.saveConfig(restaurantId, body),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['restaurantEslConfig', restaurantId] })
    },
  })
}

export function useTestEslConnection(restaurantId: number) {
  return useMutation({
    mutationFn: (apiKey: string) => eslApi.testConnection(restaurantId, apiKey),
  })
}

export function useSyncEslNow(restaurantId: number) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: () => eslApi.syncNow(restaurantId),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['restaurantEslConfig', restaurantId] })
    },
  })
}
